import React from 'react'
import BaseInput, { CommonInputProps } from './BaseInput'

interface DataInputProps extends CommonInputProps {
	value: string | undefined
	onChange?: (value: string) => void
	onBlur?: (value: string) => void
	label: string
	minDate?: string
	maxDate?: string
}

const DateInput = React.forwardRef<HTMLInputElement, DataInputProps>(
	({ value, onChange, label, readonly, minDate, maxDate, onBlur, ...props }, ref) => {
		const handleChange = (value: string | number | undefined) => {
			if (!onChange) return
			if (value) {
				onChange(value.toString())
			} else {
				onChange('')
			}
		}

		const handleBlur = (value: string | number | undefined) => {
			if (!onBlur) return
			if (value) {
				onBlur(value.toString())
			} else {
				onBlur('')
			}
		}

		return (
			<BaseInput
				ref={ref}
				readonly={readonly}
				label={label}
				value={value}
				onChange={handleChange}
				onBlur={handleBlur}
				type='date'
				minDate={minDate}
				maxDate={maxDate}
				{...props}
			/>
		)
	}
)

DateInput.displayName = 'DateInput'

export default DateInput
